import React from 'react'

import classNames from 'classnames'
import Fab from '@mui/material/Fab'
import { makeStyles } from '@mui/styles'
import Tooltip from '@mui/material/Tooltip'

import SvgIcon from 'modules/base/components/svg-icon/svg-icon'

const SpeedDialAction = props => {
  const classes = useStyles(props)

  const { onClick, icon, label, isOpen } = props

  return (
    <div className={classes.root}>
      <Tooltip
        placement='left'
        title={label}>
        <Fab
          size='small'
          onClick={onClick}
          className={
            classNames(
              classes.fab,
              {
                [classes.fabClosed]: !isOpen,
              },
            )
          } >
          <SvgIcon
            svg={icon}
            customClass={classes.icon}
            height="16px"
            width="16px" />
        </Fab>
      </Tooltip>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  root: {},
  fab: {
    margin: 8,
    backgroundColor: theme.palette.background.paper,
    cursor: 'pointer',
    transition: `${theme.transitions.create('transform', {
      duration: theme.transitions.duration.shorter,
    })}, opacity 0.8s`,
    opacity: 1,
  },
  fabClosed: {
    opacity: 0,
    transform: 'scale(0)',
  },
  icon: {
    fill: '#000000',

    '&:hover': {
      fill: '#000000',
    },
  },
}))

export default SpeedDialAction
